const ErrorIcon = () => {
    return (
        <img
            style={{ width: '100%', height: '100%' }}
            src="/images/wrong-icon.svg"
            alt="Error Icon"
        />
    );
};

export default ErrorIcon;
